import PageContainer from "@podcastsoundboard/ps-lib/components/PageContainer"

import { Helmet } from "react-helmet"
import AppBar from "../../../../components/AppBar"
import Footer from "../../../../components/Footer"
import WindowsVersionsContent from "../../../../components/WindowsVersionsContent"
import { useHashScroll } from "../../../../hooks/useHashScroll"
import { useAppSelector } from "../../../../redux"
import HomeContent from "../../../Home/components/HomeContent"
import DesktopContent from "./components/DesktopContent"
import { Box, Container, Divider } from "@podcastsoundboard/ps-lib/ui"

export default function Windows() {
  useHashScroll()
  const darkModeEnabled = useAppSelector((state) => state.darkModeEnabled)

  return (
    <>
      <Helmet titleTemplate="%s">
        <title>Podcast Soundboard for Windows</title>
        <meta
          name="description"
          content="Podcast Soundboard is the best customizable soundboard application and it features a dedicated Windows app."
        />
      </Helmet>

      <PageContainer darkModeEnabled={darkModeEnabled}>
        <AppBar
          showLogo
          invert
          title="Podcast Soundboard"
          typographyColorOverride="white"
        />

        <DesktopContent />

        <Box className="pb-20" id="downloads">
          <Container maxWidth="lg" className="py-16">
            <WindowsVersionsContent />
          </Container>
        </Box>

        <HomeContent />

        <Divider />
        <Footer />
      </PageContainer>
    </>
  )
}
